import React from "react";
import { Field, Input, Select, SectionTitle, Card, ICON_OPTIONS } from "./_shared";
import { X, Plus } from "lucide-react";

function CardEditor({ label, value, onChange, accent }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setFeature = (i, patch) => {
    const features = value.features.map((f, idx) => idx === i ? { ...f, ...patch } : f);
    onChange({ ...value, features });
  };
  const addFeature = () => onChange({ ...value, features: [...value.features, { icon: "sparkles", text: "Nueva característica" }] });
  const removeFeature = (i) => onChange({ ...value, features: value.features.filter((_, idx) => idx !== i) });

  return (
    <Card>
      <div className="flex items-center gap-2 mb-4">
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: accent }} />
        <h3 className="font-display text-xl">{label}</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Título"><Input value={value.title} onChange={(e) => set("title", e.target.value)} /></Field>
        <Field label="Subtítulo"><Input value={value.subtitle} onChange={(e) => set("subtitle", e.target.value)} /></Field>
        <Field label="CTA texto"><Input value={value.cta_label} onChange={(e) => set("cta_label", e.target.value)} /></Field>
        <Field label="CTA link"><Input value={value.cta_link} onChange={(e) => set("cta_link", e.target.value)} /></Field>
      </div>

      <div className="mt-5">
        <div className="flex items-center justify-between mb-2">
          <label className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50">Características</label>
          <button onClick={addFeature} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <div className="space-y-2">
          {value.features.map((f, i) => (
            <div key={i} className="flex gap-2">
              <Select value={f.icon} onChange={(e) => setFeature(i, { icon: e.target.value })} className="w-40">
                {ICON_OPTIONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
              </Select>
              <Input value={f.text} onChange={(e) => setFeature(i, { text: e.target.value })} />
              <button onClick={() => removeFeature(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

export default function CardsEditor({ value, onChange }) {
  return (
    <div>
      <SectionTitle title="Tarjetas Music / Teams" subtitle="Bloque debajo del 'Sobre'" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <CardEditor label="Tarjeta MUSIC" value={value.music} onChange={(v) => onChange({ ...value, music: v })} accent="#ff6a2b" />
        <CardEditor label="Tarjeta TEAMS" value={value.teams} onChange={(v) => onChange({ ...value, teams: v })} accent="#2ec9a8" />
      </div>
    </div>
  );
}
